<template>
  <b-card
    class="boxNews mb-1"
    style="height: 100%; max-height: 415px;"
    no-body
  >
    <b-card-header class="p-1 backgroundCardHeader">
      <div class="col-12 p-0 row d-flex">
        <div class="w-90 pl-1">
          <h3 class="card-title">
            <router-link
              :to="{ name: 'home-category-propate-box', params: { slug: slugName } }"
              class="d-flex align-items-center"
              title="Chỉ đạo thông tin"
            > <span :class="renderIconCategory(slugName)" /> <span class="font-be-vietnam font-size20-be-vietnam text-dark font-weight-700 ml-1">{{ titleName }} </span> </router-link>
          </h3>
        </div>
        <div class="w-10">
          <router-link :to="{ name: 'home-category-propate-box', params: { slug: 'chi-dao-thong-tin' } }">
            <span class="default_arrow justify-content-end" />
          </router-link>
        </div>
      </div>
    </b-card-header>
    <b-card-body class="px-0 py-1">
      <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="home-scroll-area"
      >
        <ul class="new-list px-1">
          <li
            v-for="(child, index) in items"
            :key="index"
          >
            <div class="w-100 d-flex align-items-start">
              <div class="w-10">
                <span class="icon_file_text" />
              </div>
              <div class="w-90">
                <h3 class="news-title font-be-vietnam font-size14-be-vietnam">
                  <router-link
                    :to="{ name: 'home-view-propate-box', params: { id: child.id, slug: child.slug } }"
                    class="link"
                    :title="child.title"
                  >{{ child.title }}
                  </router-link>
                </h3>
                <span class="icon"> {{ child.timeago }}</span>
              </div>
            </div>
          </li>
        </ul>
      </vue-perfect-scrollbar>
    </b-card-body>
  </b-card>
</template>
<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
} from 'bootstrap-vue';
import { timeago } from '@/libs/helper';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    VuePerfectScrollbar,
  },
  props: {
    items: {
      type: Array,
      default: Array,
    },
    slugName: {
      type: String,
      default: String,
    },
    titleName: {
      type: String,
      default: String,
    },
  },
  setup(props, context) {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    };
    return {
      perfectScrollbarSettings,
    }
  },
  methods: {
    resolveTimeago(time) {
      return timeago(time);
    },
    showListPart(str) {
      return str.split(',').slice(0, 3).join(',');
    },
    renderIconCategory(slugName) {
      let classIcon = 'tin_chi_dao_thong_tin';
      if (slugName === 'chi-dao-thong-tin') {
        classIcon = 'tin_chi_dao_thong_tin'
      } else if (slugName === 'tai-lieu-tham-khao') {
        classIcon = 'tin_tai_lieu_tham_khao'
      } else if (slugName === 'giao-ban-dai') {
        classIcon = 'tin_giao_ban_dai'
      }

      return classIcon;
    },
  },
}
</script>
<style lang="scss">
.home-scroll-area {
  position: relative;
  height: 100%;
}
</style>
